/* eslint-disable array-callback-return */
import React, { useState, useEffect } from 'react'
import { StyledMain, BackButton, SessionTitleContainer, SessionTitle } from './index.styled'
import { MenuSubExpansiveGroup, } from '../../';
import { CgArrowLongLeft } from 'react-icons/cg'
import { FormattedMessage } from 'react-intl';
const collections = require('./../../../assets/mock-data/collections.json')
const gamas = require('./../../../assets/mock-data/gamas.json')

const MenuExpansiveTitleComponent = ({ 
  currentSite, expandAll = false, onClickMenu = () => {}, onClickSubMenu = () => {},
  onBack = () => {}, currentGama, currentCollection
}) => {
  const [ menu, setMenuState ] = useState([]);
  const [ tempGama, setTempGama ] = useState(null);
  const [ groupActive, setGroupActive ] = useState(null);

  // eslint-disable-next-line no-unused-vars
  const activeMenu = (selected) => {
    if(selected.id === groupActive?.id){
      setGroupActive(null);
    } else {
      setGroupActive(selected);
    }
    
    if(expandAll) {
      const oldMenu = [...menu];
      const choosed = oldMenu.findIndex(item => item.id === selected.id);
      oldMenu[choosed].active = !oldMenu[choosed].active;
      onClickMenu(selected)
      setMenuState(oldMenu);
    } else {
      const oldMenu = [...menu];
      const choosed = oldMenu.map(item => {
        if(item.id === selected.id ) item.active = !item.active;
        else item.active = false;
        return item;
      })
      onClickMenu(selected)
      setMenuState(choosed);
    }
  }

  const getMenuItems = () => {
    let data = []
    
    gamas?.map(x => {
     
      if(x.available.includes(currentSite)){
        let collection = collections.filter(collection => collection.gama === x.id && collection.company === currentSite).sort(function(a, b) {
          return a.order - b.order;
        });
        
        let item = {
          title: x.label,
          slug: x.id,
          items: collection.map((y) => ({
            title: y.name,
            id: y.collection,
            active: true
          }))
        }
        data.push(item)
        return;
      }
      return;
    });
    return data
  }

  useEffect(() => {
    const menu = getMenuItems().map((item, index) => ({
      id: index,
      slug: item.slug,
      title: item.title,
      buttons: item.items,
      active: false
    }))
    setMenuState(menu);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentSite])

  useEffect(() => {
    if(currentGama !== tempGama){
      const menu = getMenuItems().filter(x => x.slug === currentGama).map((item, index) => ({
        id: index,
        slug: item.slug,
        title: item.title,
        buttons: item.items,
        active: false
      }))

      setMenuState(menu);
      setTempGama(currentGama)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentGama])


  useEffect(() => {
    if(currentGama !== tempGama){
      const menu = getMenuItems().filter(x => x.slug === currentGama).map((item, index) => ({
        id: index,
        slug: item.slug,
        title: item.title,
        buttons: item.items,
        active: true
      }))

      setMenuState(menu);
      setTempGama(currentGama)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentGama])



  return (
    <StyledMain>
        <BackButton onClick={() => onBack()}>
          <CgArrowLongLeft />
          <FormattedMessage id="back" />
        </BackButton>
        <SessionTitleContainer>
          <SessionTitle>{currentSite === "wise" ? `amorim ${currentSite}` : currentSite}</SessionTitle>
        </SessionTitleContainer>
        {menu.map(item => {          
          return (
            <MenuSubExpansiveGroup
              icontype="arrow"
              key={item.id + item.title} 
              info={item}
              active2={currentCollection}
              className={item.id === groupActive?.id ? 'active' : ''}
              clickHandler={() => {
                //activeMenu(item)
              }} 
              withoutTranslation={true}
              clickSubmenuHandler={(item) => { onClickSubMenu(item); }}
            />
          )
        })
      }        
    </StyledMain>
  )
}


export default MenuExpansiveTitleComponent;
